<div class="csat-wrapper">
  <div class="csat-modal-title">
    <div class="csat-title">Feedback</div>
    <button class="csat-modal-close-button" (click)="close()"  *ngIf="!(csatModalService.showConfirmBlock$ | async)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-template #mainBlock>
    <div class="csat-modal-info">
      {{this.question?.text}}
    </div>

    <div class="csat-modal-evaluation-block">
      <div class="csat-modal-evaluation-buttons">
        <button class="csat-modal-evaluation-button" (click)="setValue(1)" [ngClass]="value === 1 && 'active'">1
        </button>
        <button class="csat-modal-evaluation-button" (click)="setValue(2)" [ngClass]="value === 2 && 'active'">2
        </button>
        <button class="csat-modal-evaluation-button" (click)="setValue(3)" [ngClass]="value === 3 && 'active'">3
        </button>
        <button class="csat-modal-evaluation-button" (click)="setValue(4)" [ngClass]="value === 4 && 'active'">4
        </button>
        <button class="csat-modal-evaluation-button" (click)="setValue(5)" [ngClass]="value === 5 && 'active'">5
        </button>
      </div>
      <div class="csat-modal-evaluation-description">
        <div class="csat-modal-evaluation-description-text">Not Likely</div>
        <div class="csat-modal-evaluation-description-text">Very Likely</div>
      </div>
    </div>

    <div class="csat-modal-comments">
      <label class="csat-modal-comment-label" for="csat-modal-comment"> Comments (optional)</label>
      <textarea
        class="csat-modal-textarea"
        id="csat-modal-comment"
        name="csat-modal-comment"
        [(ngModel)]="comment"
      >
      </textarea>
      <div class="csat-modal-comment-hint">Did you run into any issues? What can we do better?</div>
    </div>

    <button class="csat-modal-confirm-button" (click)="sendFeedback()">Send Feedback</button>
  </ng-template>

    <div class="confirm-block" *ngIf="csatModalService.showConfirmBlock$ | async as showConfirm; else mainBlock">
      <mat-icon>check</mat-icon>Thanks for your feedback.
    </div>
</div>
